import { DialogContent, DialogTitle } from '@mui/material';
import { StyledDialog } from 'components/dialog/Dialog.styles';
import { FileManagement, FileManagementRequest } from 'api/model';
import UploadFileForm from './UploadFileForm';

type Props = {
  onClose: () => void;
  onSubmit?: (formData: FileManagementRequest) => Promise<FileManagement>;
  open: boolean;
  formId?: string;
  showGlobalOption?: boolean;
  accept?: string;
};

const UploadFileDialog = ({ open, onClose, onSubmit, formId, showGlobalOption, accept }: Props) => (
  <StyledDialog open={open} onClose={onClose} maxWidth="xl">
    <DialogTitle>File upload</DialogTitle>
    <DialogContent>
      <UploadFileForm
        onClose={onClose}
        onSubmit={onSubmit}
        formId={formId}
        showGlobalOption={showGlobalOption}
        accept={accept}
      />
    </DialogContent>
  </StyledDialog>
);

export default UploadFileDialog;
